import { observer } from "mobx-react-lite";
import React from "react";
import { Checkbox as BSCheckbox } from "react-bootstrap";
import { useFormContext } from "./Form";
import { withFormWrapper } from "./withFormWrapper";
import { StaticCheckbox } from "./StaticInput";
import { classNames } from "./utils/classNames";
export var CheckedStates;
(function (CheckedStates) {
    CheckedStates["Checked"] = "checked";
    CheckedStates["Indeterminate"] = "indeterminate";
    CheckedStates["Unchecked"] = "unchecked";
})(CheckedStates || (CheckedStates = {}));
var RawCheckbox = observer(function (_a) {
    var name = _a.name, onChange = _a.onChange, description = _a.description, disabled = _a.disabled, label = _a.label, staticFormatter = _a.staticFormatter, descriptionHidden = _a.descriptionHidden, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId;
    var _b = useFormContext(), values = _b.values, formDisabled = _b.formDisabled, isStatic = _b.isStatic;
    var handleChange = React.useCallback(function (e) {
        if (onChange) {
            onChange(e.target.checked, values.get(e.target.name));
        }
        values.set(e.target.name, e.target.checked);
    }, [onChange, values]);
    if (isStatic && !descriptionHidden) {
        return (React.createElement(StaticCheckbox, { name: name, label: description, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    var checkboxValue = values.get(name);
    var isChecked = checkboxValue === true || checkboxValue === "true";
    return (React.createElement(BSCheckbox, { name: name, checked: isChecked, onChange: handleChange, disabled: disabled || formDisabled },
        label && "".concat(label, " - "),
        React.createElement("span", { className: classNames(descriptionHidden ? "sr-only" : "") }, description)));
});
export var Checkbox = withFormWrapper({
    WrappedComponent: RawCheckbox,
    options: "checkbox",
});
